import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { createOrUpdateMaintenanceTask, deleteTask } from 'actions/maintenanceActions';
import { getAllMaintenanceTickets } from 'actions/maintenanceTicketActions';

import TaskList from 'components/shared/TaskList';

import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';

const formName = 'add_task_form';

const StyledOuterContainer = styled.div`
  padding: 24px 16px 35px;
  overflow-y: scroll;
  height: inherit;
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledRow = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  ${media.mobile`
    flex-direction: column;
  `};
`;

const StyledItem = styled.div`
  width: 100%;
  text-align: ${(props) => props.textAlign || 'left'};
  margin: ${(props) => props.margin || '0px'};
`;

const FormTitle = styled.span`
  font-size: 20px;
  font-family: 'Circular-Bold';
`;

const Tasks = (props) => {
  const {
    ticket,
    ticketStatus,
    deleteTask,
    createOrUpdateMaintenanceTask,
    getAllMaintenanceTickets,
  } = props;

  const createOrUpdateTask = async (task, taskID) => {
    await createOrUpdateMaintenanceTask(task, taskID, ticket.id);
    await getAllMaintenanceTickets();
  };

  const handleDeleteTask = async (taskID) => {
    await deleteTask(taskID, ticket.id);
    getAllMaintenanceTickets();
  };

  return (
    <React.Fragment>
      <StyledOuterContainer>
        <StyledContainer>
          {ticket.tasks.length !== 0 && (
            <StyledRow>
              <StyledItem>
                <FormTitle>{getTranslatedString('landlordPortal.taskList.tasks')}</FormTitle>
              </StyledItem>
            </StyledRow>
          )}
          <StyledRow>
            <TaskList
              tasks={ticket.tasks}
              formName={formName}
              onClickAction={createOrUpdateTask}
              deleteTask={handleDeleteTask}
              ticketStatus={ticketStatus}
            />
          </StyledRow>
        </StyledContainer>
      </StyledOuterContainer>
    </React.Fragment>
  );
};

export default connect(null, {
  deleteTask,
  createOrUpdateMaintenanceTask,
  getAllMaintenanceTickets,
})(Tasks);
